/**
 * Accepts a public key array buffer, and returns a buffer with the compressed version of the public key
 */
export const compressRawPublicKey = (rawPublicKey: ArrayBuffer) => {
  const rawPublicKeyBytes = new Uint8Array(rawPublicKey);
  const len = rawPublicKeyBytes.byteLength;

  // Drop the y coordinate
  const compressedBytes = rawPublicKeyBytes.slice(0, (1 + len) >>> 1);

  // Encode the parity of `y` in first bit
  compressedBytes[0] = 0x2 | (rawPublicKeyBytes[len - 1] & 0x01);
  return compressedBytes.buffer;
};
